import React from 'react';
import type { DBCharacter } from '../../../../services/CharacterService';
import { ITEM_DATABASE } from '../../../../../shared/content/generated/items.gen';
import { schemaSlotLabel, type EquipmentSchemaSlot } from '../../../../../shared/equipmentSlots';
import { ItemIcon } from '../../../components/ItemIcon';
import { RARITY } from '../../../theme';
import { rosterEquipmentIds } from './characterRosterPresentation';

const SLOT_ORDER: readonly EquipmentSchemaSlot[] = ['mainHand', 'head', 'chest', 'legs', 'hands', 'back', 'neck', 'feet', 'charm', 'halo'];
// Labels from the shared slot names: `feet` reads "Trail" (lane BD, D46), `charm` "Lantern" (lane BK), `halo` "Flame".
const SLOTS: ReadonlyArray<{ id: EquipmentSchemaSlot; label: string }> =
  SLOT_ORDER.map(id => ({ id, label: schemaSlotLabel(id) }));

/** A read-only view of the saved loadout, never the contents of the hero's bag. */
export const CharacterRosterGear: React.FC<{ character: DBCharacter }> = ({ character }) => {
  const equipment = rosterEquipmentIds(character);
  const equippedCount = SLOTS.filter(slot => equipment[slot.id]).length;
  return (
    <section className="hero-roster__gear" aria-label="Equipped gear">
      <header className="hero-roster__gear-heading"><h3>Equipped gear</h3><span>{equippedCount} / {SLOTS.length} slots</span></header>
      <ul className="hero-roster__gear-list">
        {SLOTS.map(slot => {
          const itemId = equipment[slot.id];
          const item = itemId ? ITEM_DATABASE[itemId] : undefined;
          const tone = item?.rarity ? RARITY[item.rarity as keyof typeof RARITY] : undefined;
          return <li key={slot.id} className="hero-roster__gear-slot" data-slot-id={slot.id}
            data-equipped={Boolean(itemId)} style={{ '--item-tone': tone } as React.CSSProperties}>
            <span className="hero-roster__gear-icon" aria-hidden="true">{itemId ? <ItemIcon itemId={itemId} size={32} /> : '—'}</span>
            <span className="hero-roster__gear-copy"><small>{slot.label}</small><strong>{item?.name ?? (itemId ? 'Unknown item' : 'Empty')}</strong></span>
          </li>;
        })}
      </ul>
      {equippedCount === 0 && <p className="hero-roster__gear-note">Your first pieces of gear await you in the world.</p>}
    </section>
  );
};
